'use strict';

const $ = jQuery = require('jquery');
window.jQuery = $;
require('foundation-sites');
const toastr = require('toastr');
require('select2');
let Masonry = require('masonry-layout');

require('./google/gmap3.min');
window.SnazzyInfoWindow = require('./google/snazzy-info-window.min');
require('./google/clustermap');
require('./google/richmarker');

var YouTubeIframeLoader = require('youtube-iframe');

function responsiveSearchbar() {
    var windowWidth = $(window).width();
    var availableSpace = $("header.oval-navigation .top-bar-left").width() + $("header.oval-navigation .top-bar-right").width();
    availableSpace = windowWidth - availableSpace;
    if (availableSpace < 500) {
        $("header.oval-navigation .top-bar-right li.zoeken").addClass("nospace");
    } else {
        $("header.oval-navigation .top-bar-right li.zoeken").removeClass("nospace");
    }
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

$(document).ready(function () {
    if ($('[data-scroll-to]').length > 0) {
        $('html, body').animate({
            scrollTop: $('[data-scroll-to]').offset().top - 100
        }, 100);
    }

    $('.cms-content h3:empty').html('&nbsp;');

    $('.cms-content iframe').wrap('<div class="responsive-embed widescreen"></div>');

    $(".chosen-select").select2();

    if ($('#map-listing').length > 0) {
        window.clustermap($('#map-listing'));
    }

    // Google Analytics triggers
    $('[ga-trigger]').on('click', function () {
        console.log('Registering trigger!', $(this).attr('ga-trigger'))

        ga('send', 'event', {
            'eventCategory': $(this).attr('ga-trigger') ? $(this).attr('ga-trigger') : $(this).text(),
            'eventAction': 'Klik',
            'eventLabel': $(this).attr('href') ? $(this).attr('href') : '',
            'transport': 'beacon'
        });
    });

    // Newsletter reveal close cookie
    $('#newsletterReveal [data-close]').on('click', function () {
        document.cookie = "COOKIE_NEWSLETTER=subscribed; max-age=10000";
    });

    if (getCookie("COOKIE_NEWSLETTER") !== 'subscribed') {
        setTimeout(function () {
            $('#newsletterReveal').foundation('open');
        }, 2000);
    }

    /** Toasts **/
    if (("[toasts]").length) {
        toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-bottom-right",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };

        $("[toasts]").find("li").each(function () {
            const state = $(this).attr("data-state");
            const message = $(this).text();

            toastr[state](message)
        });
    }

    if ($('.masonry-grid').length > 0) {
        setTimeout(function () {
            var msnry = new Masonry('.masonry-grid', {
                itemSelector: '.columns'
            });
        }, 1500);
    }

    /** Offerte generator pagination balls **/
    if ($(".quote-wrap ul.numbers").length) {
        $(window).on("resize", function () {
            quoteNumbers();
        });
        quoteNumbers();
    }

    /* Share page */
    $("a[share-page]").on("click", function () {
        $("#share-buttons").toggleClass("open");
    });

    if ($("section.member-list").length) {
        $("section.member-list ul").attr("data-equalizer", "").attr("data-equalize-on", "large");
        $("section.member-list ul li").attr("data-equalizer-watch", "");
    }

    $('.custom-select').on('mouseenter', function () {
        $(this).toggleClass('active');
    });
    $('.custom-select').on('mouseleave', function () {
        $(this).removeClass('active');
    });

    $('.custom-select ul li').on('click', function () {
        var text = $(this).text();
        var value = $(this).attr('data-value');

        $('.custom-select ul li').not($(this)).removeClass('active');
        $(this).addClass('active');

        $(this).closest('.custom-select').find('label button').addClass("selected").text(text);
        $(this).closest('.custom-select').removeClass('active');

        /** Special member search actions to fill the input **/
        if ($(".member-search").length) {
            if ($(this).closest(".custom-select").is("[data-type='working_area']")) {
                $("#banner form input#working_area").val(value);
            }
            if ($(this).closest(".custom-select").is("[data-type='service']")) {
                $("#banner form input#service").val(value);
            }
        }
        /** // Special member search actions to fill the input **/
    });

    $(document).foundation();

    if ($(".highlight").length && $(".highlight .date").length && Foundation.MediaQuery.atLeast('medium')) {
        var textHeight = $(".highlight .content").height();
        var dateHeight = $(".highlight .date").height();

        if (textHeight > dateHeight) {
            $(".highlight .date").css("height", textHeight + "px");
        }
    }

    // if ($('#map-listing').length) {
    //   window.clustermap($('#map-listing'));
    // }


    var videoID = $('#banner #player').data("videoid");

    //var tag = document.createElement('script');
    // console.log(tag);

    //tag.src = "https://www.youtube.com/iframe_api";
    // var firstScriptTag = document.getElementsByTagName('script')[0];
    // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // 3. This function creates an <iframe> (and YouTube player)
    //    after the API code downloads.
    if ($('#player').length) {
        YouTubeIframeLoader.load(function (YT) {
            let player = new YT.Player('player', {
                //height: '1920',
                //width: '1000',
                videoId: videoID,
                playerVars: {
                    'autoplay': 0,
                    'controls': 0,
                    'showinfo': 0,
                    'modestbranding': 1,
                    'hd': 1,
                    'rel': 0
                },
                events: {
                    'onStateChange': onPlayerStateChange
                }
            });

            var youtubeAction = function (action) {
                console.log(player);
                // Mute
                if (action == 'mute') {
                    player.mute();
                }
                // Unmute
                if (action == 'unmute') {
                    player.unMute();
                }
                if (action == 'play') {
                    player.playVideo();
                }
                if (action == 'pause') {
                    player.pauseVideo();
                }
            }

            function onPlayerStateChange(event) {
                if (event.data == 1) {
                    console.log("Player is started!");
                    $("#banner .vertical-aligned-text").removeClass("set");
                    $("#banner, #banner ul.breadcrumbs").addClass("videoplaying");
                    $("#banner .youtube-controls .play-pauze-buttons .yb[data-action='pause']").removeClass("hide");
                    $("#banner .youtube-controls .play-pauze-buttons .yb[data-action='play']").addClass("hide");
                } else if (event.data == 2) {
                    console.log("Player is stopped!");
                    $("#banner .vertical-aligned-text").addClass("set");
                    $("#banner, #banner ul.breadcrumbs").removeClass("videoplaying");
                    $("#banner .youtube-controls .play-pauze-buttons .yb[data-action='pause']").addClass("hide");
                    $("#banner .youtube-controls .play-pauze-buttons .yb[data-action='play']").removeClass("hide");
                }
            }

            // Youtube Controls
            if ($(".youtube-controls").length) {
                $(".youtube-controls .mute-buttons .yb").on("click", function () {
                    var action = $(this).data('action');
                    $(".youtube-controls .mute-buttons .yb").toggleClass('hide');
                    youtubeAction(action);
                });

                $(".youtube-controls .play-pauze-buttons .yb").on("click", function () {
                    $(".youtube-controls .play-pauze-buttons .yb").toggleClass('hide');
                    var action = $(this).data('action');
                    youtubeAction(action);
                });
            }
        });
    }

    // Header scroll down hide, scroll up show.
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('header.oval-navigation').outerHeight();

    function hasScrolled() {
        var st = $(this).scrollTop();

        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            $("header.oval-navigation").removeClass('nav-down').addClass('nav-up');
            $("header.oval-navigation ul li.menu").removeClass("open").find(".nav-icon").removeClass("open");
            //$("header.oval-navigation .morph-dropdown-wrapper ul li.dropdown").removeClass("active");
        } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
                $("header.oval-navigation").removeClass('nav-up').addClass('nav-down');
            }
        }
        lastScrollTop = st;
    }

    // Center text vertically in banner
    if ($("#banner .vertical-aligned-text").length) {
        let navHeight = $("header.oval-navigation").height();
        let vat = $("#banner .vertical-aligned-text");
        let h1Height = $(vat).find("h1").height() - navHeight; // - $("header.oval-navigation").height()

        $(vat).addClass("set").css("height", h1Height + "px");
    }

    $(window).scroll(function (event) {
        didScroll = true;
    });
    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    // Set top position of mininav (right nav in navigation bar).
    $("header.oval-navigation li.menu .mininav").css("top", navbarHeight + "px");

    // Zoekbalk
    $("header.oval-navigation .top-bar-right ul li.zoeken").on("click", function (e) {
        if ($(this).is(".open")) {
            if ($(e.target).is("i.material-icons")) {
                $(e.target).parent().find("form").trigger("submit");
            } else if (!$(e.target).is("input")) {
                $(this).removeClass("open");
            }
        } else {
            $(this).addClass("open");
            $(this).find("input").focus();
        }
    });

    // Searchbar bottom if there is no space.
    responsiveSearchbar();
    $(window).on("resize", function () {
        responsiveSearchbar();
    });

    // Menu (rechts)
    $("header.oval-navigation .top-bar-right li.menu").on("click", function (e) {
        if ($(e.target).is(".mininav a")) {
            console.log("is link");
        } else {
            if ($(e.target).closest('.mininav').length) {
                return false;
            } else {
                $(this).toggleClass("open").find(".hamburger .nav-icon").toggleClass("open");
            }
        }
    });

    // Custom dropdown close on mis-click.
    $(document).mouseup(function (e) {
        var container = $(".custom-select");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.removeClass("active");
        }
    });

    // Close navigation (top right li menu) if clicking outside.
    $(document).mouseup(function (e) {
        var container = $("header.oval-navigation .top-bar-right li.menu");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.removeClass("open").find(".hamburger .nav-icon").removeClass("open");
        }
    });
    // Close search bar.
    $(document).mouseup(function (e) {
        var container = $("header.oval-navigation .top-bar-right li.zoeken");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.removeClass("open");
        }
    });

    // FAQ tabbing.
    if ($("section.faq").length) {
        $("section.faq ul li").on("click", function (e) {
            if ($(e.target).closest('.answer').length) {
                // Niet sluiten als je op de content klikt.
                return;
            } else if ($(e.target).is("a.certificate")) {
                console.log("Click download certificaat button.");
            } else {
                if (!$(this).is(".open")) {
                    // Close all.
                    $("section.faq ul li").removeClass("open").find(".answer").slideUp();

                    $(this).addClass("open").find(".answer").slideDown();
                } else {
                    $(this).removeClass("open").find(".answer").slideUp();
                }
            }
        });
    }

    /** Zoek functie /zoeken first tab with results show **/
    if ($("main.searchpage").length) {
        $("main.searchpage ul.tabs li[data-result]").each(function () {
            var resultsFound = $(this).data("result");

            if (resultsFound > 0) {
                var tabWithResults = $(this).find("a").attr("href");
                $("main.searchpage ul.tabs li[data-result]").removeClass("is-active");
                $(this).addClass("is-active");
                $("main.searchpage .tabs-content .tabs-panel").removeClass("is-active");
                $("main.searchpage .tabs-content .tabs-panel" + tabWithResults).addClass("is-active");
                return false; // breaky breaky.
            }
        });
    }

    /* Search in banner toggle tabs */
    if ($("#banner .searchbox").length) {
        $("#banner .searchbox ul.searchtabs li").on("click", function () {
            var openThis = $(this).attr("data-open");
            $("#banner .searchbox ul.searchtabs li").removeClass("active");
            $(this).addClass("active");

            $("#banner .searchbox [data-show]").hide();
            $("#banner .searchbox [data-show='" + openThis + "']").show();
        });

        $("#banner .searchbox .custom-select ul li").on("click", function () {
            $("#banner .searchbox form#ized input").val($(this).attr("data-service-key"));
        });

        $("#banner .searchbox .searchfield button.submitbtn").on("click", function () {
            if ($("#banner .searchbox .custom-select form#ized").is(":visible")) {
                $("#banner .searchbox .custom-select form#ized").trigger("submit");
            } else if ($("#banner .searchbox form#izi").is(":visible")) {
                $("#banner .searchbox form#izi").trigger("submit");
            } else {
                console.log("[!!] Form not found to submit!");
            }
        });
    }

    /* Filter toggle for mobile */
    $("[data-togglefilter]").on("click", function () {
        var filterOpen = $(this).parent().is(".active");
        if (filterOpen == true) {
            $(this).closest(".filter").removeClass("active");
            $(this).parent().find(".filter-bottom").slideUp(300);
        } else {
            $(this).closest(".filter").addClass("active");
            $(this).parent().find(".filter-bottom").slideDown(300);
        }
    });

    /* If filter (/zoek-een-dienstverlener) found: functions. */
    if ($(".filter").length) {

        $(".filter ul.filters li.parent").on("click", function () {
            var isOpen = $(this).closest("ul.filters").is(".active");
            if (isOpen == true) {
                $(this).closest("ul.filters").removeClass("active");
                $(this).parent().find(".list-wrap").slideUp(300);
            } else {
                $(this).closest("ul.filters").addClass("active");
                $(this).parent().find(".list-wrap").slideDown(300);
            }
        });

        //$(".service-provider-card .top .button").on("click", function (e){
        // e.preventDefault();
        // var checked = $(this).find("input[type='checkbox']").prop('checked');
        //
        // if(!checked){
        // 	$(this).addClass("active").find("input[type='checkbox']").prop("checked", true);
        // } else {
        // 	$(this).removeClass("active").find("input[type='checkbox']").prop("checked", false);
        // }
        //});

        // Click checkbox trigger a href click.
        // $(".filter ul.filters ul label span").on("click", function (){
        // 	var location = $(this).parent().find("a").attr("href");
        // 	window.location = location;
        // });
        $(".filter ul.filters ul label").on("click", function () {
            var location = $(this).find("a").attr("href");
            window.location = location;
        });

    }
    /* // if filter length */


    if ($("main.members").length) {
        $("h3[data-toggle]").on("click", function () {
            var openThis = $(this).attr("data-toggle");
            $("h3[data-toggle]").removeClass("active");
            $(this).addClass("active");

            $("main.members [data-togglethis]").hide(); // hide all
            $("main.members [data-togglethis='" + openThis + "']").show(); // open requested
        });
    }

    $(".morph-dropdown-wrapper ul li.dropdown .content ul.switcher li[data-target]").on("mouseenter click", function () {
        if (!$(this).is(".activeclass")) {
            var requestedTab = $(this).attr("data-target");

            $(this).parent().find("li").removeClass("activeclass"); // Remove current active.
            $(this).addClass("activeclass"); // Add current active.

            $(this).closest(".content").find(".togglecats").removeClass("activeclass"); // Remove current active.
            $(this).closest(".content").find(".togglecats[data-show='" + requestedTab + "']").addClass("activeclass"); // Add current active.
        }
    });

    function quoteNumbers() {
        let numbersWidth = $(".quote-wrap ul.numbers").outerWidth();
        let numbersCount = $(".quote-wrap ul.numbers li").length;
        let numberWidth = numbersWidth / numbersCount;

        $(".quote-wrap ul.numbers li").css("max-width", numberWidth + "px");
    }

    function morphDropdown(element) {
        this.element = element;
        this.mainNavigation = this.element.find('.main-nav');
        this.mainNavigationItems = this.mainNavigation.find('.has-dropdown');
        this.dropdownList = this.element.find('.dropdown-list');
        this.dropdownWrappers = this.dropdownList.find('.dropdown');
        this.dropdownItems = this.dropdownList.find('.content');
        this.dropdownBg = this.dropdownList.find('.bg-layer');
        this.mq = this.checkMq();
        this.bindEvents();
    }

    morphDropdown.prototype.checkMq = function () {
        //check screen size
        var self = this;
        return window.getComputedStyle(self.element.get(0), '::before').getPropertyValue('content').replace(/'/g, "").replace(/"/g, "").split(', ');
    };

    morphDropdown.prototype.bindEvents = function () {
        var self = this;
        //hover over an item in the main navigation
        this.mainNavigationItems.mouseenter(function (event) {
            //hover over one of the nav items -> show dropdown
            self.showDropdown($(this));
        }).mouseleave(function () {
            setTimeout(function () {
                //if not hovering over a nav item or a dropdown -> hide dropdown
                if (self.mainNavigation.find('.has-dropdown:hover').length == 0 && self.element.find('.dropdown-list:hover').length == 0) self.hideDropdown();
            }, 50);
        });

        //hover over the dropdown
        this.dropdownList.mouseleave(function () {
            setTimeout(function () {
                //if not hovering over a dropdown or a nav item -> hide dropdown
                (self.mainNavigation.find('.has-dropdown:hover').length == 0 && self.element.find('.dropdown-list:hover').length == 0) && self.hideDropdown();
            }, 50);
        });

        //click on an item in the main navigation -> open a dropdown on a touch device
        this.mainNavigationItems.on('touchstart', function (event) {
            var selectedDropdown = self.dropdownList.find('#' + $(this).data('content'));
            if (!self.element.hasClass('is-dropdown-visible') || !selectedDropdown.hasClass('active')) {
                event.preventDefault();
                self.showDropdown($(this));
            }
        });

        //on small screens, open navigation clicking on the menu icon
        this.element.on('click', '.nav-trigger', function (event) {
            event.preventDefault();
            self.element.toggleClass('nav-open');
        });
    };

    morphDropdown.prototype.showDropdown = function (item) {
        this.mq = this.checkMq();
        if (this.mq == 'desktop') {
            var self = this;
            var selectedDropdown = this.dropdownList.find('#' + item.data('content')),
                selectedDropdownHeight = selectedDropdown.innerHeight(),
                selectedDropdownWidth = selectedDropdown.children('.content').innerWidth();

            var logoWidth = $("header.oval-navigation .top-bar-left a.logo").outerWidth();

            if ($(item).is(".left")) {
                var selectedDropdownLeft = logoWidth; // berkening vanaf het leugeu.
            } else {
                var selectedDropdownLeft = item.offset().left; // - item.outerWidth(); // - selectedDropdownWidth/2;
            }

            //update dropdown position and size
            this.updateDropdown(selectedDropdown, parseInt(selectedDropdownHeight), selectedDropdownWidth, parseInt(selectedDropdownLeft));
            //add active class to the proper dropdown item
            this.element.find('.active').removeClass('active');
            selectedDropdown.addClass('active').removeClass('move-left move-right').prevAll().addClass('move-left').end().nextAll().addClass('move-right');
            item.addClass('active');
            //show the dropdown wrapper if not visible yet
            if (!this.element.hasClass('is-dropdown-visible')) {
                setTimeout(function () {
                    self.element.addClass('is-dropdown-visible');
                }, 10);
            }
        }
    };

    morphDropdown.prototype.updateDropdown = function (dropdownItem, height, width, left) {
        this.dropdownList.css({
            '-moz-transform': 'translateX(' + left + 'px)',
            '-webkit-transform': 'translateX(' + left + 'px)',
            '-ms-transform': 'translateX(' + left + 'px)',
            '-o-transform': 'translateX(' + left + 'px)',
            'transform': 'translateX(' + left + 'px)',
            'width': width + 'px',
            'height': height + 'px'
        });

        if ($(dropdownItem).is(".left")) {
            $("header.oval-navigation .morph-dropdown-wrapper").attr("style", "");
        } else {
            $("header.oval-navigation .morph-dropdown-wrapper").css("left", 0);
        }

        this.dropdownBg.css({
            '-moz-transform': 'scaleX(' + width + ') scaleY(' + height + ')',
            '-webkit-transform': 'scaleX(' + width + ') scaleY(' + height + ')',
            '-ms-transform': 'scaleX(' + width + ') scaleY(' + height + ')',
            '-o-transform': 'scaleX(' + width + ') scaleY(' + height + ')',
            'transform': 'scaleX(' + width + ') scaleY(' + height + ')'
        });
    };

    morphDropdown.prototype.hideDropdown = function () {
        this.mq = this.checkMq();
        if (this.mq == 'desktop') {
            this.element.removeClass('is-dropdown-visible').find('.active').removeClass('active').end().find('.move-left').removeClass('move-left').end().find('.move-right').removeClass('move-right');
        }
    };

    morphDropdown.prototype.resetDropdown = function () {
        this.mq = this.checkMq();
        if (this.mq == 'mobile') {
            this.dropdownList.removeAttr('style');
        }
    };

    var morphDropdowns = [];
    if ($('.oval-navigation').length > 0) {
        $('.oval-navigation').each(function () {
            //create a morphDropdown object for each .oval-navigation
            morphDropdowns.push(new morphDropdown($(this)));
        });

        var resizing = false;

        //on resize, reset dropdown style property
        updateDropdownPosition();
        $(window).on('resize', function () {
            if (!resizing) {
                resizing = true;
                (!window.requestAnimationFrame) ? setTimeout(updateDropdownPosition, 300) : window.requestAnimationFrame(updateDropdownPosition);
            }
        });

        function updateDropdownPosition() {
            morphDropdowns.forEach(function (element) {
                element.resetDropdown();
            });

            resizing = false;
        };
    }


    $('.youtube').on('click', function () {
        var iframe = $('<iframe/>');
        iframe.attr('frameborder', 0);
        iframe.attr('allowfullscreen', '');
        iframe.attr('src', 'https://www.youtube.com/embed/' + $(this).data('embed') + '?rel=0&showinfo=0&autoplay=0')
        iframe.css('width', '100%').css("height", "196px");
        $(this).html('');
        $(this).append(iframe);
    });


    if ($('form#newsletter').length) {
        // On send
        $('form#newsletter').on("submit", function (e) {
            e.preventDefault();
            let postUrl = $(this).attr("action")
            let postData = $(this).serialize()

            // Reset.
            $('form#newsletter .field').removeClass('has-error').find('.form-error').removeClass('is-visible')

            $.ajax({
                type: "POST",
                url: postUrl,
                data: postData,
                success: function () {
                    $('form#newsletter').slideUp()
                    $('.submit-success').slideDown()
                },
                error: function (data) {
                    if (data.status == 412) {
                        // Not enough data, show errors.
                        if (data.responseJSON.form.newsletter.errors && Object.values(data.responseJSON.form.newsletter.errors).length) {
                            let errors = data.responseJSON.form.newsletter.errors

                            $.each(errors, function (key, value) {
                                // Set error class.
                                $('form#newsletter').find('.field[data-name="' + key + '"]').addClass('has-error')
                                // Set posted values.
                                $('form#newsletter').find('.field[data-name="' + key + '"] input').val(data.responseJSON.form.newsletter.data[key])
                                // Show error
                                $('form#newsletter').find('.field[data-name="' + key + '"] .form-error').addClass('is-visible').text(value)
                            })
                        } else {
                            $('.newsletter-block form#newsletter').slideUp()
                            $('.newsletter-block .submit-success').slideDown()
                        }
                    }
                }
            })

        })
    }
});


// WEBPACK FOOTER //
// ./assets/js/init.js